import styled from 'styled-components';

import { useMatchMedia } from '@xing-com/crate-hooks-use-match-media';
import { NoSSR } from '@xing-com/crate-utils-no-ssr';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { spaceXXL } from '@xing-com/tokens';

import { useAdRefresh } from '../../hooks';

import { DisplayAdLoginLeaderboard } from './leaderboard-ad';

const AdWrapper = styled.div`
  max-width: 728px;
  min-height: 90px;
  max-height: 300px;
  position: relative;
  z-index: 1;
  margin: ${spaceXXL};
`;

export const DisplayAdLoginLeaderboardSlot: React.FC = () => {
  const isSmallScreen = useMatchMedia(mediaSmallOrTiny);

  const { refreshDesktop } = useAdRefresh({
    isSmallScreen,
    slots: {
      mobile: '',
      desktop: 'leaderboard',
    },
  });

  if (isSmallScreen) {
    return null;
  }

  return (
    <AdWrapper>
      <NoSSR>
        <DisplayAdLoginLeaderboard refresh={refreshDesktop} />
      </NoSSR>
    </AdWrapper>
  );
};
